export type ProductionReportVersion = 'v1' | 'v3';

export type ProductionReportKey = 'productionOverview' | 'topPerformer';

const PRODUCTION_REPORT_VERSION_ROUTES: Record<ProductionReportKey, Record<ProductionReportVersion, string>> = {
  productionOverview: { v1: 'production-overview', v3: 'v3/production-overview' },
  topPerformer: { v1: 'performer', v3: 'v3/performer' },
};

export function getProductionReportRoute(reportKey: ProductionReportKey, isEnrolled: boolean): string {
  const routes = PRODUCTION_REPORT_VERSION_ROUTES[reportKey];
  const segment = isEnrolled ? routes.v3 : routes.v1;
  return `/production/home/${segment}`;
}
